import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import clabel from "../../../common/labels/common_en.json";
import _ from "lodash/fp";
import ApprovalInterviewMarksEntity from "../../../postExaminationProcessObjective/components/examData/ApprovalInterviewMarksEntity";
import dayjs from "dayjs";
import label from "../../../postExaminationProcessObjective/labels/postExaminationProcessObjective_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import TablePagination from "../../../common/components/TablePagination";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  uploadScannedData,
  getSubjectlistByExamId,
  getAllUnApproveInterviewMarksListPagination,
  getInterviewMarksList,
  uploadInterviewMarksData,
  updateIntervewMarks,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { ceil } from "lodash";
// import AdvertisementPostExamUpload from "../examData/AdvertisementPostExamUpload";
import AdvertisementPostExamUpload from "../../../postExaminationProcessObjective/components/examData/AdvertisementPostExamUpload";
import MastersCsvImport from "../../../postExaminationProcessObjective/components/examData/MastersCsvImport";
import {
  getYearList,
  getMainsAdvertisements,
} from "../../../common/actions/commonActions";
import ImportInterviewMarks from "../interviewSchedule/ImportInterviewMarks";
import { FiUpload } from "react-icons/fi";

const InterviewMarks = () => {
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedPreDataImport, setSelectedPreDataImport] = useState("");
  const [selectedUploadFile, setSelectedUploadFile] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedReport, setSelectedReport] = useState("");
  const [stepName, setName] = useState("interviewmarkslist");
  const [reports, setReports] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [requestDataMarks, setRequestDataMarks] = useState([]);
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  const [showImportMarks, setShowImportMarks] = useState(false);

  const dispatch = useDispatch();
  let [listCurrentPage, setListCurrentPage] = useState(0);
  const session = JSON.parse(sessionStorage.getItem("session"));
  useEffect(() => {}, [reloadItem]);

  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    if (session && session.jwtResponse.token) {
      const roleName = session.roleName;
      if (roleName === "admin") {
        setReports([
          { id: 1, name: "Pre-Data of OAS/Computer Based" },
          { id: 2, name: "Scanned/ online data of answer sheets" },
          { id: 4, name: "Post Examination Process (Descriptive)" },
          {
            id: 5,
            name: "Online Data received by Examiner/ Moderator/ Chief Moderator / Roll List",
          },
          {
            id: 6,
            name: "Scanned / online data of interview marks, proof reading data",
          },
          {
            id: 7,
            name: "Scanned / Online data of preference & Opting out and Retotaling data, proof reading data",
          },
          { id: 8, name: "Import / Export data" },
        ]);
      } else if (roleName === "examiner") {
        setReports([]);
      } else if (roleName === "moderator") {
        setReports([]);
      } else if (roleName === "chief-moderator") {
        setReports([]);
      } else if (roleName === "deskofficer") {
        setReports([{ id: 3, name: "Import/Entry of answer key data" }]);
      } else {
        setReports([]);
      }
    }
    onCancelButton();
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let rowPerPage = 10;
  const length = 50;

  useEffect(() => {
    if (stepName == "unapprovedmarks") {
      dispatch(
        getAllUnApproveInterviewMarksListPagination(listCurrentPage, rowPerPage)
      );
    }
    onCancelButton();
  }, [stepName, listCurrentPage, rowPerPage, dispatch]);

  let {
    examList,
    advertisementList,
    subjectList,
    unapprovalInterviewMarksPageNoCounter,
    allUnapprovalInterviewMarksList,
    allInterviewMarksList,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  useEffect(() => {
    setRequestDataMarks([]);
    allInterviewMarksList &&
      allInterviewMarksList.length > 0 &&
      allInterviewMarksList.map((ele, ind) => {
        let data = {
          id: ele.id,
          marks: ele.marks,
        };
        setRequestDataMarks((arr) => [...arr, data]);
      });
  }, [allInterviewMarksList]);
  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];
  let tableCounter_unapproval = unapprovalInterviewMarksPageNoCounter + 1;
  const onReportChange = (ele) => {
    let selReport = ele;
    setSelectedReport(selReport);
    setReloadItem(!reloadItem);
  };

  const handleApprovalUser = (ele) => {
    setSelectedApprovalEntity(ele);
    setApprovalEntityModal(true);
  };
  const onSubmit = (ele) => {
    let data = {};

    if (selectedReport == "6") {
      data.file = selectedUploadFile;
      data.type = "interview_marks";

      dispatch(uploadInterviewMarksData(data, selectedExam, setSelectedExam));
    } else {
      data.file = selectedUploadFile;
      data.type = "answerkey";

      dispatch(
        uploadScannedData(
          data,
          selectedReport,
          selectedExam,
          selectedPreDataImport,
          setSelectedExam,
          setSelectedPreDataImport,
          setSelectedUploadFile
        )
      );
    }

    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };
  const saveInterviewMarksChanges = () => {
    dispatch(
      updateIntervewMarks(
        selectedExam,
        requestDataMarks,
        rowPerPage,
        setIsEditable
      )
    );
  };
  const onCancelButton = () => {
    setSelectedExam("");
    setSelectedPreDataImport("");
    setSaveButtonFlag(true);
    reset();
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedYear("");
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    getMainsAdvertisement.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    allInterviewMarksList.length = 0;

    setReloadItem(!reloadItem);
  };

  const onUploadFileChange = (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    setSaveButtonFlag(false);
    let selectedValue = e.target.files[0];
    setSelectedUploadFile(selectedValue);
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    setSelectedPreDataImport("");
    subjectList.length = 0;
    setSaveButtonFlag(true);
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    if (stepName == "interviewmarkslist") {
      dispatch(getInterviewMarksList(selectedValue));
    }
    setReloadItem(!reloadItem);
  };
  const updateMarksArray = (index, val) => {
    let tempArr = requestDataMarks;
    tempArr[index].marks = val;
    setRequestDataMarks(tempArr);
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    setSelectedExam("");
    setSelectedPreDataImport("");
    examList.length = 0;
    subjectList.length = 0;
    allInterviewMarksList.length = 0;
    setSaveButtonFlag(true);
    setIsEditable(false);

    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onPreDataChange = (e) => {
    let selectedValue = e.target.value;
    setSelectedPreDataImport(selectedValue);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  return (
    <div className="commonContentArea">
      <h5 className="labelMargin"> {label.interviewMarks} </h5>
      <div
        className="tab-content border border-light "
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {/* <li className="nav-item" key="0">
            <a
              href="#"
              className={
                stepName === "importform"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="importform"
              id="importform-tab"
              onClick={() => setName("importform")}
              data-toggle="tab"
              role="tab"
              aria-controls="importform"
              aria-selected="false"
            >
              <span>{label.DataImportFrom}</span>
            </a>
          </li> */}

          <li className="nav-item" key="1">
            <a
              href="#"
              className={
                stepName === "interviewmarkslist"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="interviewmarkslist"
              id="interviewmarkslist-tab"
              onClick={() => setName("interviewmarkslist")}
              data-toggle="tab"
              role="tab"
              aria-controls="interviewmarkslist"
              aria-selected="false"
            >
              <span>{label.InterviewMarksList}</span>
            </a>
          </li>

          <li className="nav-item" key="2">
            <a
              href="#"
              className={
                stepName === "unapprovedmarks"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="unapprovedmarks"
              id="unapprovedmarks-tab"
              onClick={() => setName("unapprovedmarks")}
              data-toggle="tab"
              role="tab"
              aria-controls="unapprovedmarks"
              aria-selected="false"
            >
              <span>{label.UnapprovedInterviewMarksList}</span>
            </a>
          </li>
          <li className="ml-auto list-unstyled">
    <button
      type="reset"
      className="btn btn-primary import-button d-flex align-items-center"
      onClick={() => setShowImportMarks(true)}
    >
      <FiUpload size={18} className="mr-2" />
      {commonLabels.BUTTON_IMPORT_MARKS}
    </button>
  </li>

          {/* <li className="nav-item" key="3">
            <a
              href="#"
              className={
                stepName === "advertisementpostexamupload"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="advertisementpostexamupload"
              id="advertisementpostexamupload-tab"
              onClick={() => setName("advertisementpostexamupload")}
              data-toggle="tab"
              role="tab"
              aria-controls="advertisementpostexamupload"
              aria-selected="false"
            >
              <span>Advertisement Post Exam Upload</span>
            </a>
          </li>

          <li className="nav-item" key="4">
            <a
              href="#"
              className={
                stepName === "masterscsvimport"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              value="masterscsvimport"
              id="masterscsvimport-tab"
              onClick={() => setName("masterscsvimport")}
              data-toggle="tab"
              role="tab"
              aria-controls="masterscsvimport"
              aria-selected="false"
            >
              <span>Masters CSV Import</span>
            </a>
          </li> */}
          
        </ul>
        <div className="ml-auto">
            <button
              type="reset"
              className="btn btn-primary import-button"
              onClick={() => setShowImportMarks(true)}
            >
              <FiUpload className="mr-2 upload-icon" />
              {commonLabels.BUTTON_IMPORT_MARKS}
            </button>
          </div>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "importform"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="importform"
            role="tabpanel"
            aria-labelledby="importform-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group importFromSection">
                    <div className="row">
                      <div className="col-md-12">
                        <h5 className="ml-0"> {label.ExamDataForm}</h5>
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectReport}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedReport"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onReportChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {reports &&
                            reports.length > 0 &&
                            reports.map((element, index) => (
                              <option key={index} value={element.id}>
                                {element.name}
                              </option>
                            ))}
                        </select>
                        {_.get("selectedReport.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedAdvertiseNo"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onAdvertisementChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {advertisementList &&
                            advertisementList.length > 0 &&
                            advertisementList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedAdvertiseNo.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedExam"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onExamChange(e.target.value);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {examList &&
                            examList.length > 0 &&
                            examList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedExam.type", errors) === "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectPreDataImport}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          name="selectedPreDataImport"
                          ref={register({ required: true })}
                          onChange={(e) => {
                            onPreDataChange(e);
                          }}
                        >
                          <option key={0} value="">
                            {commonLabels.COMBO_SELECT}
                          </option>
                          {subjectList &&
                            subjectList.length > 0 &&
                            subjectList
                              .filter(
                                (element) =>
                                  element.isDeleted === false &&
                                  element.isActive === true
                              )
                              .map((element, index) => (
                                <option key={index} value={element.id}>
                                  {element.name}
                                </option>
                              ))}
                        </select>
                        {_.get("selectedPreDataImport.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label className="float-left">
                          {label.SelectUploadFile}
                          <span className="errorText">*</span>
                        </label>
                        <input
                          type="file"
                          accept=".xlsx, .xls, .csv"
                          name="selectedUploadFile"
                          onChange={(e) => {
                            onUploadFileChange(e);
                          }}
                        />
                        {_.get("selectedUploadFile.type", errors) ===
                          "required" && (
                          <p className="errorText float-left">
                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                          </p>
                        )}
                      </div>

                      <div className="form-group col-md-6 mt-3">
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={saveButtonFlag}
                          onClick={(e) => {
                            onSubmit(e);
                          }}
                        >
                          {commonLabels.BUTTON_SAVE}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "interviewmarkslist"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="interviewmarkslist"
            role="tabpanel"
            aria-labelledby="interviewmarkslist-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <div className="row">
                  <div className="form-group col-md-2">
                    <label className="float-left">
                      {commonLabels.selectYear}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedYear"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onSelectYear(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {yearList &&
                        yearList.length > 0 &&
                        yearList.map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                    </select>
                    {_.get("selectedYear.type", errors) === "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>
                  <div className="form-group col-md-3">
                    <label className="float-left">
                      {commonLabels.SelectAdvertNo}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedAdvertiseNo"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onAdvertisementChange(e.target.value);
                      }}
                    >
                      <option key={0} value="">
                        {commonLabels.COMBO_SELECT}
                      </option>
                      {getMainsAdvertisement &&
                        getMainsAdvertisement.length > 0 &&
                        getMainsAdvertisement
                          .filter(
                            (element) =>
                              element.isDeleted == false &&
                              element.isActive === true
                          )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {`${element.advertisementNo}/${element.year} - ${element.name}`}
                            </option>
                          ))}
                    </select>
                    {_.get("selectedAdvertiseNo.type", errors) ===
                      "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>
                  <div className=" col-md-3">
                    <label className="float-left">
                      {label.SelectExam}
                      <span className="errorText">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="selectedExam"
                      ref={register({ required: true })}
                      onChange={(e) => {
                        onExamChange(e.target.value);
                      }}
                    >
                      <option value="">{commonLabels.COMBO_SELECT}</option>
                      {examList &&
                        examList.length > 0 &&
                        examList
                          .filter(
                            (element) =>
                              element.isDeleted == false &&
                              element.isActive === true
                          )
                          .map((element, index) => (
                            <option key={index} value={element.id}>
                              {element.name}
                            </option>
                          ))}
                    </select>
                    {_.get("selectedExam.type", errors) === "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  </div>
                </div>
                {allInterviewMarksList && allInterviewMarksList.length > 0 && (
                  <>
                    {/* <div className="row">
                      <div className="col-md-4">
                        

                      </div>
                    </div> */}

                    <div className="row">
                      <div className="col-md-6">
                        <button
                          className="btn btn-primary m-2"
                          onClick={() => {
                            setIsEditable(true);
                          }}
                        >
                          {clabel.BUTTON_EDIT}
                        </button>
                        {isEditable == true && (
                          <button
                            className="btn btn-primary m-2"
                            onClick={() => {
                              saveInterviewMarksChanges();
                            }}
                          >
                            {clabel.BUTTON_SAVE}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <table className="table table-bordered text-center">
                          <thead className="thead-light bold-label">
                            <tr>
                              <th>{label.No}</th>
                              <th>{label.MARKS}</th>
                              <th>{label.No}</th>
                              <th>{label.MARKS}</th>
                              <th>{label.No}</th>
                              <th>{label.MARKS}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {allInterviewMarksList &&
                              allInterviewMarksList.length > 0 &&
                              allInterviewMarksList.map((ele, ind) => {
                                if (
                                  ind <
                                  Math.ceil(allInterviewMarksList.length / 3)
                                ) {
                                  return (
                                    <tr key={ind}>
                                      <td>
                                        {ind < allInterviewMarksList.length
                                          ? ind + 1
                                          : ""}
                                      </td>
                                      <td>
                                        {ind < allInterviewMarksList.length ? (
                                          isEditable != true ? (
                                            <input
                                              className=" "
                                              disabled="disabled"
                                              type="text"
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[ind].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          ) : (
                                            <input
                                              type="text"
                                              className=" large-input-box w-100"
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[ind].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {ind +
                                          Math.ceil(
                                            allInterviewMarksList.length / 3
                                          ) <
                                        allInterviewMarksList.length
                                          ? ind +
                                            Math.ceil(
                                              allInterviewMarksList.length / 3
                                            ) +
                                            1
                                          : ""}
                                      </td>
                                      <td>
                                        {ind +
                                          Math.ceil(
                                            allInterviewMarksList.length / 3
                                          ) <
                                        allInterviewMarksList.length ? (
                                          isEditable != true ? (
                                            <input
                                              disabled="disabled"
                                              type="text"
                                              className=" "
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    )
                                                ].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) +
                                                    1,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          ) : (
                                            <input
                                              type="text"
                                              className=" large-input-box w-100"
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    )
                                                ].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) +
                                                    1,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td>
                                        {ind +
                                          Math.ceil(
                                            allInterviewMarksList.length / 3
                                          ) *
                                            2 <
                                        allInterviewMarksList.length
                                          ? ind +
                                            Math.ceil(
                                              allInterviewMarksList.length / 3
                                            ) *
                                              2 +
                                            1
                                          : ""}
                                      </td>
                                      <td>
                                        {ind +
                                          Math.ceil(
                                            allInterviewMarksList.length / 3
                                          ) *
                                            2 <
                                        allInterviewMarksList.length ? (
                                          isEditable != true ? (
                                            <input
                                              disabled="disabled"
                                              type="text"
                                              className=" "
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) *
                                                      2
                                                ].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) *
                                                      2 +
                                                    1,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          ) : (
                                            <input
                                              type="text"
                                              className=" large-input-box w-100"
                                              pattern="^\d{3}\.\d{2}$"
                                              defaultValue={
                                                allInterviewMarksList[
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) *
                                                      2
                                                ].marks
                                              }
                                              onChange={(e) => {
                                                updateMarksArray(
                                                  ind +
                                                    Math.ceil(
                                                      allInterviewMarksList.length /
                                                        3
                                                    ) *
                                                      2 +
                                                    1,
                                                  e.target.value
                                                );
                                              }}
                                              onKeyPress={(e) => {
                                                const isDigit = /^\d$/.test(
                                                  e.key
                                                );
                                                const isDecimalPoint =
                                                  e.key === ".";
                                                if (isDigit) {
                                                  if (
                                                    e.target.value.length < 3
                                                  ) {
                                                    return;
                                                  }
                                                  if (
                                                    e.target.value.length ===
                                                      3 &&
                                                    !e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    !isDecimalPoint
                                                  ) {
                                                    e.target.value += ".";
                                                  }
                                                  if (
                                                    e.target.value.includes(
                                                      "."
                                                    ) &&
                                                    e.target.value.split(".")[1]
                                                      ?.length >= 2
                                                  ) {
                                                    e.preventDefault();
                                                  }
                                                } else {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  );
                                } else {
                                  return <></>;
                                }
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "unapprovedmarks"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="unapprovedmarks"
            role="tabpanel"
            aria-labelledby="unapprovedmarks-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                {allUnapprovalInterviewMarksList &&
                allUnapprovalInterviewMarksList.totalNoOfRecords > 0 ? (
                  <>
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          {unapprovalEntityHeader &&
                            unapprovalEntityHeader.map((itm, ind) => (
                              <th
                                key={ind}
                                className={`${
                                  itm === "No." || itm === "Action"
                                    ? "text-center"
                                    : ""
                                }`}
                              >
                                {itm}
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allUnapprovalInterviewMarksList &&
                          allUnapprovalInterviewMarksList.entityApprovalDtoList &&
                          allUnapprovalInterviewMarksList.entityApprovalDtoList
                            .length > 0 &&
                          allUnapprovalInterviewMarksList.entityApprovalDtoList.map(
                            (ele, index) => {
                              return (
                                <tr key={index}>
                                  <td className="w-5 text-center">
                                    {tableCounter_unapproval++}
                                  </td>
                                  <td className=" word-break">
                                    {ele.entityApprovalAction.actionLabel}
                                  </td>
                                  <td className="width-5">
                                    {ele.entityApprovalAction.level == 1
                                      ? label.APPROVAL_LEVEL_1_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 2
                                      ? label.APPROVAL_LEVEL_2_PENDING
                                      : ""}
                                    {ele.entityApprovalAction.level == 3
                                      ? label.APPROVAL_LEVEL_3_PENDING
                                      : ""}
                                  </td>
                                  <td className=" word-break width-10">
                                    {ele.entityApprovalAction.updatedAt
                                      ? dayjs(
                                          ele.entityApprovalAction.updatedAt
                                        ).format("DD/MM/YYYY h:mm A")
                                      : ""}
                                  </td>

                                  <td className="w-10 word-break width-20">
                                    {ele.entityApprovalAction.entityApprovalDto
                                      .detail &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults.length > 0 &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults[0].exam &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults[0].exam
                                        .name}{" "}
                                    <br />{" "}
                                    {ele.entityApprovalAction.entityApprovalDto
                                      .detail &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults.length > 0 &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults[0].exam &&
                                      ele.entityApprovalAction.entityApprovalDto
                                        .detail.interviewResults[0].exam
                                        .nameDvng}
                                  </td>

                                  <td>
                                    {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                      "_",
                                      " "
                                    )}
                                  </td>

                                  <td className=" word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalTypeLabel
                                    }
                                  </td>
                                  <td className=" word-break">
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.firstName
                                    }{" "}
                                    {
                                      ele.entityApprovalAction.entityApprovalDto
                                        .approvalByUser.lastName
                                    }
                                  </td>

                                  <td className=" word-break">
                                    {ele.entityApprovalAction.comments}
                                  </td>
                                  <td className="text-center word-break width-12">
                                    {(session.roleName == "superadmin" ||
                                      session.roleName == "desk officer") && (
                                      <button
                                        type="button"
                                        className="pull-right btn btn-outline-primary btn-sm custom-button"
                                        onClick={() => {
                                          handleApprovalUser(ele);
                                        }}
                                      >
                                        {clabel.REVIEW}
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                    <TablePagination
                      paginationFor="un_interviewmarks_list"
                      rowPerPage={rowPerPage}
                      setListCurrentPage={setListCurrentPage}
                      totalCount={
                        allUnapprovalInterviewMarksList.totalNoOfRecords
                      }
                    />
                  </>
                ) : (
                  <div className="text-center">
                    <font className="text-danger">{clabel.NO_DATA_FOUND}</font>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "advertisementpostexamupload"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="advertisementpostexamupload"
            role="tabpanel"
            aria-labelledby="advertisementpostexamupload-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <AdvertisementPostExamUpload />
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "masterscsvimport"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="masterscsvimport"
            role="tabpanel"
            aria-labelledby="masterscsvimport-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <MastersCsvImport />
              </div>
            </div>
          </div>
        </div>

        {approvalEntityModal && (
          <ApprovalInterviewMarksEntity
            showModal={approvalEntityModal}
            setShowModal={setApprovalEntityModal}
            setSelectedApprovalEntity={selectedApprovalEntity}
          />
        )}
        <ImportInterviewMarks
          showImportMarks={showImportMarks}
          setShowImportMarks={setShowImportMarks}
          onCancelButton={onCancelButton}
        />
      </div>
    </div>
  );
};

export default InterviewMarks;
